import React, { useEffect, useRef, useState } from 'react';
import { Copy, Check } from 'lucide-react';

import { lienPosition } from './fleetRules';

/**
 * « Copier la position » : met dans le presse-papiers un lien carte des
 * coordonnées, à coller dans WhatsApp pour un chauffeur ou un dépanneur.
 */
export default function CopierPosition({ vehicule, className = '' }) {
  const lien = lienPosition(vehicule);
  const [copie, setCopie] = useState(false);
  const minuterie = useRef(null);
  useEffect(() => () => window.clearTimeout(minuterie.current), []);
  if (!lien) return null;

  const copier = async (event) => {
    event.stopPropagation();
    try {
      await navigator.clipboard.writeText(lien);
    } catch {
      // Presse-papiers refusé (page non sécurisée, ancien navigateur) : le
      // lien s'ouvre, l'utilisateur le copie depuis la barre d'adresse.
      window.open(lien, '_blank', 'noopener');
      return;
    }
    setCopie(true);
    window.clearTimeout(minuterie.current);
    minuterie.current = window.setTimeout(() => setCopie(false), 2000);
  };

  return (
    <button
      type="button"
      onClick={copier}
      className={`inline-flex items-center justify-center gap-1.5 rounded border border-border bg-card px-2 py-1 text-sm hover:bg-muted ${className}`}
    >
      {copie ? <Check className="h-4 w-4 text-success" aria-hidden="true" /> : <Copy className="h-4 w-4" aria-hidden="true" />}
      {copie ? 'Lien copié' : 'Copier la position'}
    </button>
  );
}
